import { createMarkdownChipNode } from './createMarkdownChipNode';

/**
 * markdown：长文本粘贴 chip，失焦解析展开成 markdown-module。
 * chip 自身 contentEditable（对齐 V1 markdown/render.ts），实现见 createMarkdownChipNode.tsx。
 */
export const MarkdownNode = createMarkdownChipNode(
  {
    chipClass: 'rte-markdown-input',
    errorClass: 'rte-markdown-error',
    dataType: 'markdown',
    defaultPlaceholder: '粘贴 markdown 文本',
  },
  'MarkdownNode',
);
